var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntersection1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.63,
    height: 61,
    viewBox: "0 0 100.63 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M-6356.341-4471a148.6,148.6,0,0,1-92.289-61H-6348v61Z",
    transform: "translate(6448.63 4532)",
    fill: "#1a8eb4",
    opacity: 0.53
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersection1);
export default __webpack_public_path__ + "static/media/Intersection1.94b817dc69392afc1bdd449707001640.svg";
export { ForwardRef as ReactComponent };